module.exports = "pegasus_template/assets/themelp1/small/13.png";